import { SizableText, XStack } from '@mythical/ui'
import useMutation from 'app/hooks/use-mutation'
import { deleteMutation, deleteResult } from 'app/mutations/comments/delete'
import { observer } from 'mobx-react-lite'

import { Button } from 'app/components/primitive/Button'
import { StyledDialog } from 'app/components/primitive/StyledDialog'

const query = deleteMutation()

interface Props {
  id: string
  modalOpen: boolean
  onDelete: () => void
  setModalOpen: (open: boolean) => void
}

export const DeleteModal = observer<Props>(
  ({ id, modalOpen, onDelete, setModalOpen }) => {
    const { loading, data, error, makeRequest } = useMutation(
      query,
      deleteResult,
    )

    const handleDelete = async () => {
      const data = await makeRequest({ id })

      if (data?.success) {
        onDelete()
        setModalOpen(false)
      }
    }

    return (
      <StyledDialog
        open={modalOpen}
        onOpenChange={(open) => setModalOpen(open)}
        title="Delete Comment"
        description="Are you sure you want to delete this comment?"
      >
        {(error || (data && !data.success)) && (
          <SizableText color="$fgError" ta='center'>
            {error?.message || data?.reason || 'Unknown Error'}
          </SizableText>
        )}

        <XStack gap="$2" jc="center">
          <Button theme="secondary" onPress={() => setModalOpen(false)}>
            Cancel
          </Button>
          <Button theme="primary" onPress={handleDelete} loading={loading}>
            {!data?.success && 'Delete'}
            {data && data.success && 'Deleted'}
          </Button>
        </XStack>
      </StyledDialog>
    )
  },
)
